// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"427":"oral-serein-bac-reussi","832":"formation-latin-serein","962":"home","964":"product","983":"products"}[chunkId] || chunkId) + "." + {"349":"5750a4b3","427":"99d49ac0","832":"9de9274d","962":"3d095b7d","964":"eefa558b","983":"431bdc46"}[chunkId] + ".js";
};